import { BaseApiService } from "@services/baseApiService";
import {
  ActivityOutputDTO,
  ActivityFilterParams,
} from "@features/process/types";
import { ApiResponse, ApiError } from "@/types/api";
import { api } from "@services/api";

export class ProcessService extends BaseApiService<ActivityOutputDTO> {
  constructor() {
    super("processes");
  }

  async fetchActivities(
    filters: ActivityFilterParams = {},
  ): Promise<ApiResponse<ActivityOutputDTO[]> | ApiError> {
    const formattedFilters: Record<string, string> = {};

    if (filters.search) formattedFilters.search = filters.search;
    if (filters.product) formattedFilters.product = filters.product;
    if (filters.status) formattedFilters.status = filters.status;
    if (filters.priority !== undefined)
      formattedFilters.priority = filters.priority.toString();
    if (filters.startDate) formattedFilters.startDate = filters.startDate;
    if (filters.endDate) formattedFilters.endDate = filters.endDate;
    if (filters.page !== undefined)
      formattedFilters.page = filters.page.toString();
    if (filters.limit !== undefined)
      formattedFilters.limit = filters.limit.toString();

    console.log("📡 Fetching activities with filters:", formattedFilters);
    return await this.fetchActivePhasesStats(formattedFilters);
  }

  // Specific endpoint for fetching active phases stats
  async fetchActivePhasesStats(
    filters: Record<string, string> = {},
  ): Promise<ApiResponse<ActivityOutputDTO[]> | ApiError> {
    const queryString = new URLSearchParams(filters).toString();
    const url = `${this.baseUrl}/active-phases/stats${queryString ? `?${queryString}` : ""}`;

    console.log("📡 Requesting activities from:", url);
    return await api.request<ActivityOutputDTO[]>(url);
  }
}

export const processService = new ProcessService();
